<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Location Info</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Location Info</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="card p-3">
          <div class="card">
            <div class="card-body">
              <form class="floating-labels" novalidate>
                <h3 class="font-weight-bold">Owner Information</h3>
                <h3 class="m-b-30 font-weight-bolder">
                  {{ prInfo.ownerName }} - {{ prInfo.ownerEmail }}
                  <!-- <a
                    href="/cdn-cgi/l/email-protection"
                    class="__cf_email__"
                    data-cfemail="bdcedcd3cedccfd48ffddad0dcd4d193ded2d0"
                    >[email&#160;protected]</a
                  > -->
                </h3>
                <h3 class="font-weight-bold h3Spacing">General Information</h3>
                <form class="floating-labels">
                 <div class="row">
                  <div class="col-md-6 mb-3">
                   <div class="form-row">
                    <select
                      class="form-control custom-select"
                      v-model="prInfo.timeZoneId"
                    >
                      <option
                        v-for="tz in timezones"
                        :key="tz.timeZoneId"
                        :value="tz.timeZoneId"
                      >
                        [{{
                          tz.offset + "  " + tz.abbreviation + "] " + tz.name
                        }}
                      </option>
                    </select>
                    <span class="bar"></span>
                      <label for="" style="margin-top:-26px;font-weight:bold;">Time Zone<span  style="color:red"> *</span></label>
                      </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                    <span class="p-float-label">
                     <InputText
                     id="practiceName"
                     maxlength="50"
                     type="text"
                     v-model="prInfo.practiceName"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Business Name<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>
                 </div>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="form-row">

                      <Dropdown
                        v-model="prInfo.practiceTypeId"
                        :options="practiceTypes"
                        optionLabel="name"
                        optionValue="practiceTypeId" 
                        placeholder="Select a Practice Type"
                        :filter="true"
                        filterPlaceholder="Find Practice Type"
                        class="multiselect-custom"
                        @change="practiceTypeChanged()"
                      />
                       <span class="bar"></span>
                      <label for="" style="margin-top:-26px;font-weight:bold;">Practice Type<span  style="color:red"> *</span></label>
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                      <span class="p-float-label">
                     <InputText
                     id="website"
                     maxlength="50"
                     type="text"
                       v-model="prInfo.webSite"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Website<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>
                </div>
                </form>

                <h3 class="font-weight-bold h3Spacing">Contact Information</h3>
                <form class="floating-labels">
                <div class="form-row">
                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                      <span class="p-float-label">
                     <InputText
                     id="pnumber"
                      v-mask="'###-###-####'"
                     type="tel"
                     maxlength="50"
                     v-model="prInfo.phone"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Phone<span  style="color:red"> *</span></label>
                  </span>
                  </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                       <span class="p-float-label">
                     <InputText
                     id="pfax"
                      v-mask="'###-###-####'"
                     type="tel"
                     maxlength="50"
                     v-model="prInfo.fax"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Fax<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                  <span class="p-float-label">
                     <InputText
                     id="email"
                     type="text"
                     maxlength="30"
                     v-model="prInfo.email"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Email<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>
                </div>
              </form>

                <h3 class="font-weight-bold h3Spacing">Address Information</h3>
                <form class="floating-labels">
                <div class="form-row">
                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                      <span class="p-float-label">
                     <InputText
                     id="street"
                     type="text"
                     maxlength="80"
                     v-model="prInfo.streetAddress"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Street<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                     <span class="p-float-label">
                     <InputText
                     id="city"
                     type="text"
                     maxlength="30"
                     v-model="prInfo.city"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">City<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label
                    for=""
                    style="
                      margin-left: 0px;
                      margin-top: -24px;
                      font-weight: bold;
                    "
                    >State<span  style="color:red"> *</span></label
                  >
                    <div class="form-group m-b-40">
                    <select
                    class="form-control custom-select"
                    tabindex="1"
                    v-model="prInfo.state"
                  >
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District Of Columbia</option>
                      <option value="FL">Florida</option>

                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                  </select>

                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <div class="form-group m-b-40">
                      <span class="p-float-label">
                     <InputText
                     id="zip"
                     v-mask="'#####'"
                     type="number"
                     v-model="prInfo.zip"
                     class="float-class"
                     style="width:700px;"
                    />
                  <label id="font1" for="">Zip<span  style="color:red"> *</span></label>
                  </span>
                    </div>
                  </div>
                </div>
              </form>

                <button
                  class="btn btn-lg mt-4 btn-outline-success col-12"
                  type="button"
                  name="locInfoUpd_btn"
                  @click="updateClick" id="locInfoUpd_btn"
                >
                  Update
                </button>
              </form>
            </div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PracticeInfo",

  data() {
    return {
      practiceName: "",
      website: "",
      pnumber: "",
      pfax: "",
      email: "",
      street: "",
      city: "",
      state: "",
      zip: "",

      //loader
      loader:"",
      //Timer
      TimerObject: {},
      prInfo: "",
      timezones: [],
      practiceTypes: null,
      EmployeeRolesStr: []
    };
  }, // end data()

  methods: {
    async updateClick() {
        //debugger // eslint-disable-line no-debugger
      if (
        this.prInfo.practiceName == ""
      ) {
        this.ShowWarning("Practice Name is required");
        event.preventDefault();
        return;
      }
      if (this.prInfo.webSite == "") {
        this.ShowWarning("Website is required");
        event.preventDefault();
        return;
      }
      if (this.prInfo.phone == "") {
        this.ShowWarning("Phone is required");
        event.preventDefault();
        return;
      }
      if (this.prInfo.fax == "") {
        this.ShowWarning("Fax is required");
        event.preventDefault();
        return;
      }
       if (this.prInfo.phone.length < 12) {
        this.ShowWarning("Phone lenght must be 10");
        event.preventDefault();
        return;
      }
      if (this.prInfo.fax.length < 12) {
        this.ShowWarning("Fax lenght must be 10");
        event.preventDefault();
        return;
      }
      if (this.prInfo.email == "") {
        this.ShowWarning("Email is required");
        event.preventDefault();
        return;
      }
      if (
        this.prInfo.streetAddress == ""
      ) {
        this.ShowWarning("Street Address is required");
        event.preventDefault();
        return;
      }
      if (this.prInfo.city == "") {
        this.ShowWarning("City is required");
        event.preventDefault();
        return;
      }
      if (this.prInfo.state == "") {
        this.ShowWarning("State is required");
        event.preventDefault();
        return;
      }
      if (this.prInfo.zip == "") {
        this.ShowWarning("Zip is required");
        event.preventDefault();
        return;
      } else if (this.prInfo.email.length > 0) {
        if (this.prInfo.email != null) {
          if (!this.validEmail(this.prInfo.email)) {
            this.Validity(this.e);
          }
        }
      }
        $( "#locInfoUpd_btn" ).prop( "disabled", true );
      this.intDummyComm();
      let ppr = {
        dc: this.dummyComm,
        pr: this.prInfo,
      };

      var loader = this.$loading.show({
        // Optional parameters
          color: '#03a9f3'
        });
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Practices/UpdatePracticeInfo",
        data: ppr,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          this.dummyComm = res.data;
          if (this.dummyComm.auditFlag <= 0) this.errorToastUpd('Unable to Update')
          else {
             console.log('ok') 
             this.successToastUpd();
          }
          $( "#locInfoUpd_btn" ).prop( "disabled", false );
        })
        .catch(function (error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          }
        })
        .finally(() => { 
          this.ResetLogoutTime();
          loader.hide(); 
        });
    },

handleRole(){
   this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
         if(this.EmployeeRolesStr.length > 0){
       this.val = this.EmployeeRolesStr.filter(
      (i)=>i.name == 'Manage Location'
     );
       if(this.val[0].canUpdate == 0){$('button[name="locInfoUpd_btn').hide();}
}
},

//loader
 loader_1() {
    this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });
 },

  StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    loadInit() {
      //alert(localStorage.OSversion);
      this.intDummyComm();

      //this.dummyComm.pure = this.m_makeCommString('6001', 'r');

      const url = this.SERVER + "/VNSPRAAPI/Practices/GTPRAINF";
      this.lastErrorCode = -1;

      this.loader_1();
      this.axiosGetData(url, 1);
      this.StartLogoutTime();
    },

    //------------------------------------------ Common Methods
    async axiosGetData(myUrl, what) {
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
        .then((res) => {
          // if everything goes well -- we will get data
          this.lastErrorCode = 1;
          if (what === 1) {
            this.loader.hide();
             //debugger// eslint-disable-line no-debugger

            this.prInfo = res.data.pr;
            this.timezones = res.data.tz;
            this.practiceTypes = res.data.prty;
          }
        })
        .catch(function (error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          //this.lastErrorCode = this.lastErrorCode;
          this.ResetLogoutTime();
        });
    }, // axiosGetData
  }, // methods

  mounted() {
    if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    clearTimeout(this.loadObj);
    this.handleRole();
    this.loadInit();
  },
  unmounted() {
      clearTimeout(this.TimerObject);
    },
};
</script>

<style scoped>
.multiselect-custom {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* border-bottom: 2px solid rgb(240, 141, 11); */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
  width: 100%;
  z-index: 2000px;
}
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* / box-shadow: none; / */
  width: 98%;
}

.float-class,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  /* / border-bottom: 2px solid rgb(240, 141, 11); / */
  border-bottom: 1px solid rgb(235, 235, 235);
  box-shadow: none;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
#font1{
    font-weight: 600;
    font-size: 15px;
}
</style>